import getLocalString from "constants/Localization";
import { useUpdateOrganizationProposalLayoutContentSettingsMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateOrganizationProposalLayoutContentSettings() {
  const [mutation, { loading, data, error }] =
    useUpdateOrganizationProposalLayoutContentSettingsMutation({
      refetchQueries: ["getOrganizationProposalLayoutContentSettings"],
    });

  const [updateOrganizationProposalLayoutContentSettings, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateOrganizationProposalLayoutContentSettings",
    },
    {
      successMessage: getLocalString(
        "organization.update-proposal-layout-content-settings-success"
      ),
      failureMessage: getLocalString(
        "organization.update-proposal-layout-content-settings-failure"
      ),
    }
  );

  return [updateOrganizationProposalLayoutContentSettings, context] as const;
}
